module.exports = __webpack_public_path__ + "media/images/map_icons/Tennis-5959a6b13a441e662206fd7a5a5c69ab.svg";